import { KeenSliderPlugin } from 'keen-slider';

/** Keep the dashboard's three-second cadence, including after manual navigation. */
export const dashboardAutoplay: KeenSliderPlugin = slider => {
  let timer: ReturnType<typeof setTimeout> | undefined;
  let hovering = false;
  let focused = slider.container.contains(document.activeElement);
  let dragging = false;
  let destroyed = false;
  const clear = () => { clearTimeout(timer); timer = undefined; };
  const schedule = () => {
    clear();
    if (destroyed || hovering || focused || dragging || document.hidden ||
        (slider.track.details?.slides.length || 0) < 2) return;
    timer = setTimeout(() => {
      timer = undefined;
      slider.next();
      schedule();
    }, 3000);
  };
  const enter = () => { hovering = true; clear(); };
  const leave = () => { hovering = false; schedule(); };
  const focus = () => { focused = true; clear(); };
  const blur = (event: FocusEvent) => {
    if (!slider.container.contains(event.relatedTarget as Node | null)) { focused = false; schedule(); }
  };
  slider.on('created', () => {
    slider.container.addEventListener('mouseenter', enter);
    slider.container.addEventListener('mouseleave', leave);
    slider.container.addEventListener('focusin', focus);
    slider.container.addEventListener('focusout', blur);
    document.addEventListener('visibilitychange', schedule);
    schedule();
  });
  slider.on('dragStarted', () => { dragging = true; clear(); });
  slider.on('dragEnded', () => { dragging = false; schedule(); });
  // Scheduling at the start avoids adding the transition duration to each interval.
  slider.on('animationStarted', schedule);
  slider.on('updated', schedule);
  slider.on('destroyed', () => {
    destroyed = true;
    clear();
    slider.container.removeEventListener('mouseenter', enter);
    slider.container.removeEventListener('mouseleave', leave);
    slider.container.removeEventListener('focusin', focus);
    slider.container.removeEventListener('focusout', blur);
    document.removeEventListener('visibilitychange', schedule);
  });
};
